import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Lang } from '../../../types/common-types'
import { State } from '../../../state-actions-reducers'
import styles from './SexSelect.module.scss'
import AccountForm from '../../../types/account-form.types'

interface SexSelectProps {  lang: Lang
  accountForm: AccountForm
}

export function SexSelect({
  lang,
  accountForm,
}: SexSelectProps) {
  const { watch, setValue, formState: { errors } } = useFormContext<State>()
  const state = watch()

  return (
    <label>
      <p>{accountForm.sex.label[lang]}</p>
      <div className={styles.sexButtonBox}>
        {accountForm.sexValues.map((sex: any, key: number) => {
          return (
            <button
              data-test-id={key === 1 ? 'male' : 'female'}
              key={key}
              data-key={key}
              className={
                +state.sex === key + 1
                  ? styles.sexButton + ' ' + styles.active
                  : !!errors.sex && state.sex === '0'
                    ? styles.sexButton + ' ' + styles.invalid
                    : styles.sexButton
              }
              onClick={() =>
                setValue('sex', `${key + 1}`, { shouldDirty: true })
              }
            >
              <span>{sex[lang]}</span>
            </button>
          )
        })}
      </div>
    </label>
  )
}
